import React, { useState, useEffect, useCallback, useMemo } from 'react';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/relacionados_admin.php';

const IconSearch = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconPlus   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconTrash  = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUp     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="18 15 12 9 6 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconDown   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="6 9 12 15 18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

const keyOf = (p) => `${p.tipo}:${p.id}`;
const soles = (n) => `S/. ${Number(n || 0).toFixed(2)}`;

export default function TabRelacionados({ origenTipo, origenId, origenTitulo, origenPrecio, onToast }) {
  const [catalogo,    setCatalogo]    = useState([]);
  const [seleccion,   setSeleccion]   = useState([]);
  const [cargando,    setCargando]    = useState(true);
  const [guardando,   setGuardando]   = useState(false);
  const [busqueda,    setBusqueda]    = useState('');

  const cargar = useCallback(async () => {
    setCargando(true);
    try {
      const [rc, rl] = await Promise.all([
        fetch(`${API}?action=catalogo`).then(r => r.json()),
        fetch(`${API}?action=list&origen_tipo=${origenTipo}&origen_id=${origenId}`).then(r => r.json()),
      ]);
      if (rc.success) setCatalogo(rc.data || []);
      if (rl.success) setSeleccion(rl.data || []);
    } catch {
      onToast?.('Error cargando productos relacionados', 'error');
    } finally {
      setCargando(false);
    }
  }, [origenTipo, origenId, onToast]);

  useEffect(() => { cargar(); }, [cargar]);

  const seleccionadas = useMemo(
    () => new Set(seleccion.map(keyOf)),
    [seleccion]
  );

  const disponibles = useMemo(() => {
    const q = busqueda.trim().toLowerCase();
    return catalogo.filter(p => {
      if (seleccionadas.has(keyOf(p))) return false;
      if (p.tipo === origenTipo && p.id === Number(origenId)) return false;
      if (!q) return true;
      return p.titulo.toLowerCase().includes(q) || (p.categoria || '').toLowerCase().includes(q);
    });
  }, [catalogo, seleccionadas, busqueda, origenTipo, origenId]);

  const agregar = (p) => {
    if (seleccion.length >= 12) { onToast?.('Máximo 12 relacionados', 'error'); return; }
    setSeleccion(s => [...s, { ...p, descuento_pct: 0 }]);
  };
  const quitar = (p) => setSeleccion(s => s.filter(x => keyOf(x) !== keyOf(p)));
  const mover  = (idx, dir) => {
    const arr = [...seleccion];
    const j = idx + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[idx], arr[j]] = [arr[j], arr[idx]];
    setSeleccion(arr);
  };
  const setPct = (p, val) => {
    const pct = Math.max(0, Math.min(90, parseFloat(val) || 0));
    setSeleccion(s => s.map(x => keyOf(x) === keyOf(p) ? { ...x, descuento_pct: pct } : x));
  };

  const guardar = async () => {
    setGuardando(true);
    try {
      const r = await fetch(`${API}?action=save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          origen_tipo: origenTipo,
          origen_id:   origenId,
          items: seleccion.map((p, i) => ({
            destino_tipo:  p.tipo,
            destino_id:    p.id,
            orden:         i,
            descuento_pct: p.descuento_pct,
          })),
        }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      onToast?.('Productos relacionados guardados');
    } catch (e) {
      onToast?.(e.message || 'No se pudo guardar', 'error');
    } finally {
      setGuardando(false);
    }
  };

  /* Resumen del paquete */
  const totalSinDto = Number(origenPrecio || 0) + seleccion.reduce((a, p) => a + p.precio, 0);
  const totalConDto = Number(origenPrecio || 0) + seleccion.reduce(
    (a, p) => a + p.precio * (1 - p.descuento_pct / 100), 0
  );
  const ahorro = totalSinDto - totalConDto;

  const card = { background:'#fff', border:'1.5px solid rgba(130,216,179,.25)', borderRadius:12, padding:'.75rem .9rem' };
  const miniBtn = { background:'none', border:'none', cursor:'pointer', color:'#5a6a63', padding:'.15rem', display:'flex' };

  if (cargando) return <p style={{ color:'#5a6a63', fontSize:'.88rem' }}>Cargando…</p>;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'1.4rem' }}>

      <p style={{ fontSize:'.85rem', color:'#5a6a63', lineHeight:1.6, margin:0 }}>
        Los productos que elijas aquí aparecen en la página de detalle de <strong>{origenTitulo}</strong> y,
        si les pones descuento, en el carrito como paquete.
      </p>

      {/* ── Seleccionados ── */}
      <div>
        <p style={{ fontSize:'.7rem', fontWeight:700, letterSpacing:'.08em', textTransform:'uppercase', color:'#5a6a63', marginBottom:'.6rem' }}>
          Relacionados ({seleccion.length})
        </p>

        {seleccion.length === 0 ? (
          <div style={{ ...card, color:'#9ca3af', fontSize:'.85rem', textAlign:'center', padding:'1.3rem' }}>
            Todavía no hay productos relacionados. Añádelos desde la lista de abajo.
          </div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:'.5rem' }}>
            {seleccion.map((p, idx) => (
              <div key={keyOf(p)} style={{ ...card, display:'flex', alignItems:'center', gap:'.8rem' }}>
                <div style={{ display:'flex', flexDirection:'column' }}>
                  <button style={{ ...miniBtn, opacity: idx===0?.3:1 }} disabled={idx===0} onClick={()=>mover(idx,-1)}><IconUp/></button>
                  <button style={{ ...miniBtn, opacity: idx===seleccion.length-1?.3:1 }} disabled={idx===seleccion.length-1} onClick={()=>mover(idx,1)}><IconDown/></button>
                </div>

                {p.imagen_url
                  ? <img src={p.imagen_url} alt="" style={{ width:42, height:42, borderRadius:8, objectFit:'cover', flexShrink:0 }}/>
                  : <div style={{ width:42, height:42, borderRadius:8, background:'#edfaf4', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                      {p.tipo === 'curso' ? '🎓' : '📄'}
                    </div>}

                <div style={{ flex:1, minWidth:0 }}>
                  <strong style={{ fontSize:'.85rem', color:'#111614', display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                    {p.titulo}
                  </strong>
                  <span style={{ fontSize:'.73rem', color:'#5a6a63' }}>
                    {p.tipo === 'curso' ? 'Curso' : 'Material'} · {soles(p.precio)}
                    {p.descuento_pct > 0 && (
                      <> → <strong style={{ color:'#14736C' }}>{soles(p.precio * (1 - p.descuento_pct/100))}</strong></>
                    )}
                  </span>
                </div>

                <div style={{ display:'flex', alignItems:'center', gap:'.3rem', flexShrink:0 }}>
                  <input type="number" min="0" max="90" step="1"
                    value={p.descuento_pct}
                    onChange={e => setPct(p, e.target.value)}
                    style={{ width:58, padding:'.35rem .5rem', borderRadius:8, border:'1.5px solid rgba(130,216,179,.4)', fontFamily:'inherit', fontSize:'.82rem', textAlign:'right' }}/>
                  <span style={{ fontSize:'.78rem', color:'#5a6a63' }}>% dto.</span>
                </div>

                <button onClick={()=>quitar(p)} title="Quitar"
                  style={{ ...miniBtn, color:'#dc2626' }}><IconTrash/></button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ── Resumen del paquete ── */}
      {seleccion.length > 0 && (
        <div style={{ background:'#edfaf4', border:'1.5px solid rgba(130,216,179,.35)', borderRadius:12, padding:'.9rem 1.1rem', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'.6rem' }}>
          <div>
            <p style={{ margin:0, fontSize:'.72rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'.08em', color:'#4db88a' }}>
              Paquete completo
            </p>
            <p style={{ margin:'.2rem 0 0', fontSize:'.8rem', color:'#5a6a63' }}>
              {origenTitulo} + {seleccion.length} producto{seleccion.length>1?'s':''}
            </p>
          </div>
          <div style={{ textAlign:'right' }}>
            {ahorro > 0 && <s style={{ fontSize:'.8rem', color:'#9ca3af', marginRight:'.5rem' }}>{soles(totalSinDto)}</s>}
            <strong style={{ fontSize:'1.05rem', color:'#111614' }}>{soles(totalConDto)}</strong>
            {ahorro > 0 && <p style={{ margin:'.1rem 0 0', fontSize:'.75rem', fontWeight:700, color:'#14736C' }}>Ahorra {soles(ahorro)}</p>}
          </div>
        </div>
      )}

      {/* ── Buscador y catálogo ── */}
      <div>
        <p style={{ fontSize:'.7rem', fontWeight:700, letterSpacing:'.08em', textTransform:'uppercase', color:'#5a6a63', marginBottom:'.6rem' }}>
          Añadir producto
        </p>

        <div style={{ display:'flex', alignItems:'center', gap:'.5rem', background:'#f3f8f5', borderRadius:10, padding:'.5rem .8rem', marginBottom:'.7rem', color:'#5a6a63' }}>
          <IconSearch/>
          <input type="text" placeholder="Buscar curso o material…"
            value={busqueda} onChange={e=>setBusqueda(e.target.value)}
            style={{ flex:1, border:'none', background:'none', outline:'none', fontFamily:'inherit', fontSize:'.85rem', color:'#111614' }}/>
        </div>

        <div style={{ maxHeight:260, overflowY:'auto', display:'flex', flexDirection:'column', gap:'.4rem', paddingRight:'.2rem' }}>
          {disponibles.length === 0 ? (
            <p style={{ color:'#9ca3af', fontSize:'.84rem', padding:'.6rem' }}>
              {busqueda ? 'Sin resultados.' : 'No hay más productos con precio disponibles.'}
            </p>
          ) : disponibles.map(p => (
            <div key={keyOf(p)} style={{ ...card, display:'flex', alignItems:'center', gap:'.7rem', padding:'.55rem .8rem' }}>
              <span style={{ fontSize:'1rem', flexShrink:0 }}>{p.tipo === 'curso' ? '🎓' : '📄'}</span>
              <div style={{ flex:1, minWidth:0 }}>
                <strong style={{ fontSize:'.83rem', color:'#111614', display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.titulo}</strong>
                <span style={{ fontSize:'.72rem', color:'#5a6a63' }}>{p.categoria} · {soles(p.precio)}</span>
              </div>
              <button onClick={()=>agregar(p)}
                style={{ display:'flex', alignItems:'center', gap:'.3rem', background:'#edfaf4', color:'#14736C', border:'1.5px solid rgba(130,216,179,.4)', borderRadius:100, padding:'.35rem .8rem', fontFamily:'inherit', fontWeight:700, fontSize:'.78rem', cursor:'pointer', flexShrink:0 }}>
                <IconPlus/> Añadir
              </button>
            </div>
          ))}
        </div>
      </div>

      <div>
        <button onClick={guardar} disabled={guardando}
          style={{ background:'#032D29', color:'#8BCAAF', border:'none', borderRadius:100, padding:'.65rem 1.5rem', fontFamily:'inherit', fontWeight:700, fontSize:'.85rem', cursor: guardando?'wait':'pointer', opacity: guardando?.6:1 }}>
          {guardando ? 'Guardando…' : 'Guardar relacionados'}
        </button>
      </div>
    </div>
  );
}